window.addEventListener("load", function () {
	(function ($) {
		$(".haus-mega-menu-hamburger-button-open").on("click", function (e) {
			e.preventDefault();
			$("nav.wp-block-haus-mega-menu").addClass("opened");
		});
		$(".haus-mega-menu-hamburger-button-close").on("click", function (e) {
			e.preventDefault();
			$("nav.wp-block-haus-mega-menu").removeClass("opened");
		});
		// disable plus icon if submenu has no items
		$(".wp-block-haus-mega-menu-inner-blocks > li > span").each(function () {
			var submenuChildren = $(this)
				.next(".haus-mega-menu-submenu-wrapper")
				.find("a");
			if (!submenuChildren.length) {
				$(this).find("i").hide();
			}
		});
		$(document).on(
			"click",
			".wp-block-haus-mega-menu.opened .wp-block-haus-mega-menu-submenu > span",
			function (e) {
				// check if submenu has children
				var submenuChildren = $(this)
					.next(".haus-mega-menu-submenu-wrapper")
					.find("a");
				console.log(submenuChildren.length);
				if (submenuChildren.length) {
					e.preventDefault();
					$(this).next().slideToggle();
				}
			}
		);
	})(jQuery);
});
